import React from "react";
import { InvoiceInfo } from "types/list-invoice";

export type ComparatorInvoiceType = (i1: InvoiceInfo, i2: InvoiceInfo) => number
export type InvoiceCellComponent = React.FC<{invoice: InvoiceInfo}>


interface InvoiceColumnInterface {
    title: string
    width: string
    comparatorFn: ComparatorInvoiceType
    cellComponent: InvoiceCellComponent
}


export type InvoicesColumn = keyof InvoicesTableColumnsType
export const columnsInvoiceOrder: InvoicesColumn[] = ["date", "number", "priceNoTaxes", "priceWithTaxes", "status"]

export type InvoicesTableColumnsType = {
    date: InvoiceColumnInterface
    number: InvoiceColumnInterface
    priceNoTaxes: InvoiceColumnInterface
    priceWithTaxes: InvoiceColumnInterface
    status: InvoiceColumnInterface
}
